{
  "name": "enbw-rdp-onedv-portal",
  "version": "1.6.0",
  "private": true,
  "type": "module",
  "workspaces": [
    "apps/*",
    "packages/*"
  ],
  "scripts": {
    "start": "npm run dev:frontend:local",
    "build": "npm run build:shared && npm run build:backend && npm run build:frontend",
    "build:shared": "npm run build -w @onedv-portal/shared",
    "build:backend": "npm run build -w @onedv-portal/backend",
    "build:frontend": "npm run build -w @onedv-portal/frontend",
    "test": "npm run test:shared && npm run test:backend && npm run test:frontend && npm run test:scripts",
    "test:shared": "npm run test -w @onedv-portal/shared",
    "test:backend": "npm run test -w @onedv-portal/backend",
    "test:frontend": "npm run test -w @onedv-portal/frontend",
    "test:scripts": "vitest run scripts -c vitest.scripts.config.ts",
    "test:coverage": "npm run test:coverage:shared && npm run test:coverage:backend && npm run test:coverage:frontend && npm run test:coverage:scripts && npm run coverage:rewrite-lcov-for-sonar",
    "test:coverage:shared": "npm run test:coverage -w @onedv-portal/shared",
    "test:coverage:backend": "npm run test:coverage -w @onedv-portal/backend",
    "test:coverage:frontend": "npm run test:coverage -w @onedv-portal/frontend",
    "test:coverage:scripts": "vitest run scripts --coverage -c vitest.scripts.config.ts",
    "coverage:rewrite-lcov-for-sonar": "tsx scripts/rewrite-lcov-paths-for-sonar.ts",
    "cy:install": "cypress install",
    "cy:open": "cypress open",
    "cy:component": "cypress run --component --reporter junit --reporter-options \"mochaFile=apps/frontend/test-results/cypress/component/results-[hash].xml,toConsole=true\"",
    "cy:e2e": "cypress run --e2e",
    "cy:e2e:dev": "CYPRESS_BASE_URL=https://portal-dev.vk.enbw.com cypress run --e2e",
    "cy:e2e:demo": "CYPRESS_BASE_URL=https://portal-demo.vk.enbw.com cypress run --e2e",
    "dev:backend": "npm run dev -w @onedv-portal/backend",
    "dev:frontend": "npm run dev -w @onedv-portal/frontend",
    "dev:frontend:local": "npm run dev -w @onedv-portal/frontend -- --configuration local",
    "dev:mock:endia-callback": "sst shell -- tsx scripts/trigger-endia-callback.ts",
    "dev:mock:indicative-offer": "sst shell -- tsx scripts/send-indicative-offer.ts",
    "deploy": "SST_TELEMETRY_DISABLED=1 sst deploy",
    "setup:sst-secrets": "./scripts/set-sst-secrets-from-ssm.sh",
    "sst:install": "NO_BUN=true sst install --print-logs",
    "sst:dev": "SST_TELEMETRY_DISABLED=1 sst dev",
    "sst:remove": "SST_TELEMETRY_DISABLED=1 sst remove",
    "typecheck": "tsc --noEmit -p tsconfig.json",
    "lint": "npm run lint:frontend && npm run lint:backend && npm run lint:shared",
    "lint:shared": "npm run lint -w @onedv-portal/shared",
    "lint:backend": "npm run lint -w @onedv-portal/backend",
    "lint:frontend": "npm run lint -w @onedv-portal/frontend",
    "format": "prettier . --check",
    "format:fix": "prettier . --write",
    "generate:json-schema": "tsx scripts/export-json-schema.ts",
    "docs:render": "for f in docs/diagrams/*.d2; do d2 \"$f\" \"${f%.d2}.png\"; done"
  },
  "dependencies": {
    "@traversable/zod": "0.0.57",
    "zod": "4.4.0"
  },
  "devDependencies": {
    "@aws-sdk/client-ssm": "3.1012.0",
    "@types/node": "22.12.0",
    "@vitest/coverage-v8": "4.0.15",
    "eslint": "9.39.1",
    "fast-xml-builder": "1.1.7",
    "fast-xml-parser": "5.7.0",
    "otplib": "13.4.1",
    "prettier": "3.7.4",
    "sst": "3.17.38",
    "typescript": "5.9.3",
    "typescript-eslint": "8.48.1",
    "vitest": "4.0.15"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "0.25.11",
    "@rollup/rollup-linux-x64-gnu": "4.52.5",
    "sst-linux-x64": "3.17.38"
  },
  "overrides": {
    "@babel/core": "7.29.7",
    "browserslist": "4.28.7",
    "fast-xml-parser": "5.7.0",
    "picomatch": "4.0.4",
    "fast-xml-builder": "1.1.7",
    "js-cookie": "3.0.7"
  },
  "engines": {
    "node": ">=24",
    "npm": ">=11.10.0"
  }
}
